export default __webpack_public_path__ + "media/images/users/user-jenny-myers-70x70-24ed49a42aa7c06d9ac039eeb5fd37a2.jpg";